export default __webpack_public_path__ + "static/thumb-1a59e47cf52a50e3aea72f101026e24c.png";